import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-download-tooltip-icon',
  imports: [MatTooltip],
  templateUrl: './download-tooltip-icon.component.html',
  styleUrls: ['./download-tooltip-icon.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DownloadTooltipIconComponent {
  @Input() text?: string;
}
